import * as moment from 'moment';

export interface DateFormats {
	[lang: string]: moment.LocaleSpecification;
}

export const DEFAULT_FORMAT: moment.LocaleSpecification = {
	longDateFormat: {
		LT: 'h:mm A',
		LTS: 'h:mm:ss A',
		L: 'MM/DD/YYYY',
		l: 'M/D/YYYY',
		LL: 'DD MMM YYYY',
		ll: 'ddd, MM/DD/YYYY',
		LLL: 'MMMM Do YYYY LT',
		lll: 'ddd, MM/DD/YYYY LT',
		LLLL: 'dddd, MMMM Do YYYY LT',
		llll: 'ddd, MMM D YYYY LT'
	}
};

export const LONG_DATE_FORMATS: DateFormats = {
	'en': {
		...DEFAULT_FORMAT
	},
	'de': {
		longDateFormat: {
			LT: 'hh:mm',
			LTS: 'hh:mm:ss',
			L: 'DD-MM-YYYY',
			l: 'D-M-YYYY',
			LL: 'DD MMM YYYY',
			ll: 'ddd DD-MM-YYYY',
			LLL: 'MMMM Do YYYY hh:mm',
			lll: 'ddd DD-MM-YYYY hh:mm',
			LLLL: 'dddd, MMMM Do YYYY hh:mm',
			llll: 'ddd, MMM D YYYY hh:mm'
		}
	}
};
